import { useClipboard } from '@calendly/clipboard';
import { useOnValueChange } from '@calendly/hooks';
import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { CheckIcon } from '@calendly/ui/components/icons';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
const styledSpanCss = "s7v1v7f";
const StyledSpan = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(styledSpanCss, props.className)} />;
});
const initialStateIsCopiedCss = "izt7tty";
const initialStateCss = "i1216pct";
const InitialState = forwardRef((props, ref) => {
  const {
    isCopied,
    ...restProps
  } = props;
  return <StyledSpan ref={ref} {...restProps} className={classNames(initialStateCss, {
    [initialStateIsCopiedCss]: isCopied
  }, props.className)} />;
});
const copiedStateCss = "c16xpngq";
const CopiedState = forwardRef((props, ref) => <StyledSpan ref={ref} {...props} className={classNames(copiedStateCss, props.className)} />);
const copyButtonDecorationSuccessCss = "c1f60bed";
const copyButtonWeightNormalCss = "cb7zzt1";
const copyButtonWeightBoldCss = "c17aw8xv";
const copyButtonCss = "cg9vxjf";
const CopyButton = forwardRef((props, ref) => {
  const {
    decoration,
    weight,
    ...restProps
  } = props;
  return <Button ref={ref} {...restProps} decoration={decoration} className={classNames(copyButtonCss, {
    [copyButtonDecorationSuccessCss]: decoration?.toString() === 'success',
    [copyButtonWeightNormalCss]: weight?.toString() === 'normal',
    [copyButtonWeightBoldCss]: weight?.toString() === 'bold'
  }, props.className)} />;
});
export const ClipboardButton = ({
  children,
  content,
  fontWeight = 'bold',
  successMessage = null,
  successStyle = 'primary',
  trackEvent = null,
  ...buttonProps
}) => {
  const [Wrapper, ref, isCopied] = useClipboard(content);
  useOnValueChange(isCopied, () => {
    if (isCopied && trackEvent) {
      trackEvent();
    }
  });
  return <Wrapper>
      <CopyButton {...buttonProps} weight={fontWeight} decoration={isCopied ? successStyle : buttonProps.decoration} ref={ref} aria-label={isCopied ? I18n.t('publisher.action.copied_to_clipboard') : undefined}>
        <InitialState isCopied={isCopied}>
          {children}
        </InitialState>
        {isCopied && <CopiedState>
            <CheckIcon />
            {successMessage}
          </CopiedState>}
      </CopyButton>
    </Wrapper>;
};
ClipboardButton.propTypes = {
  successStyle: PropTypes.oneOf(['primary', 'success']),
  successMessage: PropTypes.string,
  fontWeight: PropTypes.oneOf(['normal', 'bold']),
  content: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  trackEvent: PropTypes.func
};

require("./clipboard_button.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./clipboard_button.js");